import * as rdd from "react-device-detect";
import axios from "axios";

export const uiLogUrl = "/api/uiLogs";

const generateUiLogPayload = (error, type, errorCode) => {
  const userAgent = `${rdd?.browserName} ${rdd?.fullBrowserVersion} ${rdd?.osName} ${rdd?.osVersion}`;
  const {
    message,
    stackTrace = "",
    statusText,
    method,
    url,
    data,
    status,
    requestHeaders,
  } = error || {};

  let errorPayload = {
    logType: "ERROR",
    userAgent,
    timestamp: new Date().toISOString(),
  };

  if (type === "runtime")
    errorPayload = {
      ...errorPayload,
      message,
      errorType: "Runtime",
      logId: errorCode,
      stackTrace,
    };
  else if (type === "api")
    errorPayload = {
      ...errorPayload,
      method,
      errorType: "API",
      message: `${status} ${statusText}`,
      logId: Date.now(),
      stackTrace: {
        url,
        responseData: data,
        requestHeaders,
      },
    };
  return errorPayload;
};

export const logUiError = async (error, type, errorCode) => {
  try {
    await axios.post(uiLogUrl, generateUiLogPayload(error, type, errorCode));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("uiLogs error", err);
  }
};
